import { createEffect, createStore, sample } from "effector";
import { UserAuthModule } from "@features/student/auth/model";
import { DEFAULT_INTRO_LESSONS } from "@features/shared/entities/intro-lessons";
import { StudentPersonalApi } from "@features/shared/api/student-personal.api";

const userAuthModule = new UserAuthModule();
const auth = userAuthModule.getContract();

export const $introLessons = createStore(DEFAULT_INTRO_LESSONS);
export const $personalPlanEnabled = createStore(false);

const getCanGenerateLearningPlanFx = createEffect(async () => {
    const response = await StudentPersonalApi.getCanGenerateLearningPlan();

    return response;
});

sample({
    clock: auth.effects.getOnboardingDataFx.doneData,
    filter: (data) => data.introLessons.length > 0,
    fn: (data) => data.introLessons,
    target: $introLessons
});

sample({
    clock: auth.events.authenticated,
    target: getCanGenerateLearningPlanFx
});

sample({
    clock: getCanGenerateLearningPlanFx.doneData,
    fn: (s) => s.canGenerate,
    target: $personalPlanEnabled
});

sample({
    clock: getCanGenerateLearningPlanFx.failData,
    fn: () => false,
    target: $personalPlanEnabled
});
